/**
 *  In order for this function to work on iOS, it needs to be called in a handler
 *  for user gesture
 * */
export async function getBrowserMicPermission(): Promise<PermissionState> {
  // The Permissions API only reports the current state. A `prompt` result does
  // not ask the customer for access, so we must still call getUserMedia from
  // this user gesture to open the browser permission prompt.
  if (navigator.permissions && navigator.permissions.query) {
    const status = await navigator.permissions.query({
      name: "microphone" as PermissionName,
    });

    if (status.state !== "prompt") {
      return status.state;
    }
  }

  // This path also supports iOS, where the Permissions API is unavailable.
  try {
    const stream = await navigator.mediaDevices.getUserMedia({ audio: true });
    stream.getTracks().forEach((track) => track.stop());

    return "granted";
  } catch {
    return "denied";
  }
}
